console.log('%c[Query Filter] topic-podcasts view.js loaded', 'color: lime; font-weight: bold;');

import { store, getElement } from '@wordpress/interactivity';

const updateURL = async ( action, value, name ) => {
	const url = new URL( action );
	if ( value || name === 's' ) {
		url.searchParams.set( name, value );
	} else {
		url.searchParams.delete( name );
	}
	const { actions } = await import( '@wordpress/interactivity-router' );
	await actions.navigate( url.toString() );
};

const updateCheckboxStates = () => {
	// Function to sync checkbox state with URL after navigation
	setTimeout(() => {
		const urlParams = new URLSearchParams(window.location.search);
		
		// Find all checkboxes in topic-podcasts blocks
		const blocks = document.querySelectorAll('[data-wp-interactive="query-filter"].topic-podcasts');
		
		blocks.forEach(block => {
			const queryVar = block.dataset.queryVar;
			const currentSelection = urlParams.get(queryVar);
			
			// Update checkbox state and classes
			const checkboxes = block.querySelectorAll('input[type="checkbox"]');
			checkboxes.forEach(checkbox => {
				const topicId = checkbox.dataset.topicId;
				const label = checkbox.closest('label');
				
				if (!topicId) {
					// This is "All Topics" button - selected if no other terms are selected
					checkbox.checked = !currentSelection;
					if (label) {
						label.classList.toggle('is-checked', !currentSelection);
					}
				} else {
					// This is a regular term
					const isSelected = currentSelection == topicId;
					checkbox.checked = isSelected;
					if (label) {
						label.classList.toggle('is-checked', isSelected);
					}
				}
			});
			
			// Update button text
			const header = block.querySelector('.checkbox-dropdown-header .selected-text');
			if (header) {
				const emptyLabel = 'All Topics'; // or get from attributes
				
				if (!currentSelection) {
					header.textContent = emptyLabel;
				} else {
					// Get term name from checkbox
					const selectedCheckbox = block.querySelector(`input[data-topic-id="${currentSelection}"]`);
					if (selectedCheckbox) {
						const label = selectedCheckbox.closest('label');
						if (label) {
							const termName = label.textContent.trim();
							header.textContent = termName;
						}
					}
				}
			}
		});
	}, 100); // Small delay to complete navigation
};

const { state } = store( 'query-filter', {
	actions: {
		*navigate( e ) {
			console.log('[Query Filter] topic-podcasts navigate triggered');
			e.preventDefault();
			const { actions } = yield import( '@wordpress/interactivity-router' );
			yield actions.navigate( e.target.value );
		},

		*toggleCheckbox( e ) {
			console.log('[Query Filter] topic-podcasts toggleCheckbox triggered');
			e.preventDefault();
			
			const { ref } = getElement();
			const checkbox = ref;
			
			if (!checkbox) return;
			
			// For topic-podcasts only one checkbox can be selected
			const block = checkbox.closest('.topic-podcasts');
			if (block) {
				// Uncheck all other checkboxes
				const allCheckboxes = block.querySelectorAll('input[type="checkbox"]');
				allCheckboxes.forEach(cb => {
					if (cb !== checkbox) {
						cb.checked = false;
						const label = cb.closest('label');
						if (label) {
							label.classList.remove('is-checked');
						}
					}
				});
				
				// Set current checkbox state
				if (checkbox.checked) {
					const label = checkbox.closest('label');
					if (label) {
						label.classList.add('is-checked');
					}
				}
			}
		},

		*search( e ) {
			e.preventDefault();
			const { ref } = getElement();
			let action, name, value;
			if ( ref.tagName === 'FORM' ) {
				const input = ref.querySelector( 'input[type="search"]' );
				action = ref.action;
				name = input.name;
				value = input.value;
			} else {
				action = ref.closest( 'form' ).action;
				name = ref.name;
				value = ref.value;
			}

			// Don't navigate if the search didn't really change.
			if ( value === state.searchValue ) return;

			state.searchValue = value;

			yield updateURL( action, value, name );
		},
	},
} );

// Initialize after page load
document.addEventListener('DOMContentLoaded', () => {
	updateCheckboxStates();
});

// Update after navigation
document.addEventListener('wp-navigation', () => {
	updateCheckboxStates();
});
